<template>
  <div class="directory-detail__n-home-detail" v-if="info">
    <!-- <van-nav-bar :title="info.xuanfei_name" class="app-nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar> -->

    <div class="directory-detail__radius-arrow" @click="back()">
      <div class="directory-detail__rt-pos"></div>
    </div>

    <!-- swiper1 -->
    <swiper class="swiper swiper-container" :options="swiperOptionTop" ref="swiperTop" style="position: relative;">
      <swiper-slide class="slide-1" style="text-align: center;" v-for="(item, index) in info.img_url" :key="index">
        <van-image :src="item" :show-loading="false" fit="contain" @click="openImg(index)" />
      </swiper-slide>
    </swiper>

    <div class="app-content">
      <div class="directory-detail__notice">
        <van-notice-bar left-icon="volume-o" scrollable :text="notice" />
        <div  class="directory-detail__icon2">
          {{ $t('zise.zhuyi') }}
        </div>
      </div>
      <div>
        <p>id:{{ info.id }}</p>
        <p>{{ $t('zise.jihuochakan') }}</p>
      </div>
      <div class="directory-detail__score-2">
        <div class="directory-detail__score">
          <div>{{ $t('zise.meitidengji') }}</div>
          <div class="directory-detail__da-fen">88</div>
          <div>{{ $t('zise.yannzhi') }}</div>
        </div>
        <div class="directory-detail__phone-id">
          <div>{{ $t('zise.xiangxidizhi') }}：{{ $t('zise.jihuohouxianshi') }}</div>
          <div>{{ $t('zise.lianxiren') }}：{{ $t('zise.jihuohouxianshi') }}</div>
        </div>
      </div>

      <div class="app-information">
        <div class="app-info">
          <div class="directory-detail__age"><i class="directory-detail__icon3"></i><span>
              {{ $t('setting.base_setting') }} {{ info.birthday }}{{ $t('zise.sui') }},
              {{ $t('xuanfei.height') }} {{ info.height }}</span></div>
          <div class="directory-detail__age"><i class="directory-detail__icon4"></i> <span>{{ $t('xuanfei.address') }}
              {{ info.address }}</span></div>
          <div class="directory-detail__age"><i class="directory-detail__icon5"></i><span>{{ $t('zise.fuwuxiangqing') }} {{ $t('zise.jihuoxianshi') }}</span></div>
        </div>
        <div class="directory-detail__text-bo"> {{ $t('zise.fuwuneirong') }} </div>
      </div>
      <!-- <div class="prize-draw-page__img"><img src="/img/1.68ced5fe.jpg" alt=""></div> -->

      <van-image v-for="(item, index) in info.img_url" :key="index" :src="item" :show-loading="false" fit="contain"
        @click="openImg(index)" />
    </div>




    <!-- <div class="directory-detail__detail-content">
      <div class="directory-detail__product-description">
        <div class="directory-detail__title1">{{ $t('xuanfei.summary') }}:</div>
        <p>{{ info.content }}</p>
      </div>
      <div class="">
        <div class="product-detail">
          <div class="directory-detail__products-title">
            <h2 class="directory-detail__h4">{{ $t('xuanfei.kieuAnh') }}</h2>
          </div>
          <div class="product-attribute product-single">
            <div>
              <div class="directory-detail__title1">{{ $t('xuanfei.information') }}</div>
              <div class="directory-detail__nav-thumbs nav mb-3" id="information_post">
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.Passenger_price') }}:</div>
                  <div>{{ info.price }}</div>
                </div>
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.birth') }}:</div>
                  <div>{{ info.birthday }}</div>
                </div>
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.address') }}:</div>
                  <div>{{ info.address }}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="directory-detail__title1">{{ $t('xuanfei.identification') }}</div>
              <div class="directory-detail__nav-thumbs nav mb-3" id="size_post">
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.height') }}:</div>
                  <div>{{ info.height }}</div>
                </div>
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.weight') }}:</div>
                  <div>{{ info.weight }}</div>
                </div>
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.round1') }}:</div>
                  <div>{{ info.one }}</div>
                </div>
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.round2') }}:</div>
                  <div>{{ info.two }}</div>
                </div>
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.round3') }}:</div>
                  <div>{{ info.three }}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="directory-detail__title1">{{ $t('xuanfei.informationServices') }}</div>
              <div class="directory-detail__nav-thumbs nav mb-3" id="service_post">
                <div class="directory-detail__information-box">
                  <div class="app-title">{{ $t('xuanfei.Service') }}:</div>
                  <div>{{ info.service }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { ImagePreview } from 'vant';

import dayjs from 'dayjs'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOptionTop: {
        loop: true,
        loopedSlides: 50, // looped slides should be the same
        spaceBetween: 10
      },
      btnLogin: false,
      info: null,
      commentlist: [],
      notice: '',
      dayjs
    };
  },
  created() {
    this.$http({
      method: 'get',
      url: 'xuanfeidata',
      data: { id: this.$route.query.id }
    }).then(res => {
      console.log(res.data)
      this.info = res.data

    })

    this.getBasicConfig()
  },

  mounted() {
  },
  methods: {

    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.notice = res.data.notice || '';
      })

    },
    openImg(index) {
      let that = this;
      ImagePreview({
        images: that.info.img_url,
        startPosition: index,
      });
    },
    back() {
      if (this.url) {

        this.$router.replace({ path: '/account' })
      } else {
        window.history.back();
      }
    },

  }
};
</script>

<style scoped lang="less" src="./detail.styles.less"></style>
